

  function addToCartSticky() {
    const variantInput = document.getElementById("sticky-variant-id");
    const cartDrawer = document.querySelector("cart-drawer");
    const variantId = variantInput ? variantInput.value : null;
    
    if (variantId && cartDrawer) {
      cartDrawer.addItemToCart(variantId);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const selects = document.querySelectorAll('.sticky-variant-select');
    const hiddenInput = document.getElementById('sticky-variant-id');
    const variants = (window.__sbPdp && Array.isArray(window.__sbPdp.variants)) ? window.__sbPdp.variants : [];

    function updateStickyVariant() {
      const selectedOptions = Array.from(selects).map(select => select.value);
      const matchedVariant = variants.find(variant =>
        variant.options.every((opt, idx) => opt === selectedOptions[idx])
      );
      if (matchedVariant) {
        hiddenInput.value = matchedVariant.id;
      }
    }
    selects.forEach(select => {
      select.addEventListener('change', updateStickyVariant);
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    // Format delivery dates with proper localization
    const deliveryDateElements = document.querySelectorAll('.delivery-date[data-timestamp]');
    
    deliveryDateElements.forEach(function(element) {
      try {
        const timestamp = parseInt(element.dataset.timestamp, 10) * 1000; // Convert Liquid seconds to JS milliseconds
        const locale = element.dataset.locale || 'en';
        const format = element.dataset.format || 'weekday_month_day';
        const jsDate = new Date(timestamp);
        
        // Define formatting options based on the selected format
        let options = {};
        switch (format) {
          case 'weekday_month_day':
            options = { weekday: 'long', month: 'long', day: 'numeric' };
            break;
          case 'month_day_weekday':
            options = { month: 'long', day: 'numeric', weekday: 'long' };
            break;
          case 'month_day':
            options = { month: 'long', day: 'numeric' };
            break;
          case 'day_month':
            options = { day: 'numeric', month: 'long' };
            break;
          default:
            options = { weekday: 'long', month: 'long', day: 'numeric' };
        }
        
        const formatter = new Intl.DateTimeFormat(locale, options);
        let formattedDate = formatter.format(jsDate);
        
        // For specific formats, adjust the order
        if (format === 'month_day_weekday') {
          // Convert "Monday, January 5" to "January 5, Monday"
          const parts = formatter.formatToParts(jsDate);
          const weekday = parts.find(part => part.type === 'weekday')?.value;
          const month = parts.find(part => part.type === 'month')?.value;
          const day = parts.find(part => part.type === 'day')?.value;
          if (weekday && month && day) {
            formattedDate = `${month} ${day}, ${weekday}`;
          }
        }
        
        element.textContent = formattedDate;
        
      } catch (error) {
        console.error('Error formatting delivery date:', error);
        // Fallback to simple format if error occurs
        const timestamp = parseInt(element.dataset.timestamp, 10) * 1000;
        const jsDate = new Date(timestamp);
        element.textContent = jsDate.toLocaleDateString();
      }
    });
  });
